import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import LocalStorage from '../Services/LocalStorage'
import Api from '../Services/Api'
import { percorsoConsentito } from '../Utils/sezioniAccesso'

// Le sezioni sono uguali per tutti: una richiesta sola per sessione di pagina.
let sezioniPromise = null
const caricaSezioni = () => {
  sezioniPromise = sezioniPromise || Api.get('/sezioni').then(res => (res.ok ? res.data : null)).catch(() => null)
  return sezioniPromise
}

const ProtectedRoute = ({ children }) => {
  const jwt = LocalStorage.get('jwt')
  const user = LocalStorage.get('user')
  const { pathname } = useLocation()
  const [sezioni, setSezioni] = useState(undefined)

  useEffect(() => {
    if (!jwt || !user) return
    let attivo = true
    caricaSezioni().then(tutte => {
      if (!tutte) sezioniPromise = null // errore: riprova alla prossima pagina
      if (attivo) setSezioni(tutte)
    })
    return () => { attivo = false }
  }, [pathname]) // eslint-disable-line react-hooks/exhaustive-deps

  // Se non c'è token o user, reindirizza al login
  if (!jwt || !user) {
    return <Navigate to='/' replace />
  }

  if (sezioni === undefined) return null
  if (!percorsoConsentito(pathname, sezioni, user.sezioni)) {
    return <Navigate to='/home' replace />
  }

  return children
}

export default ProtectedRoute
